export const FETCH_FIREBASE_DATA_REQUEST = 'FETCH_FIREBASE_DATA_REQUEST';
export const FETCH_FIREBASE_DATA_SUCCESS = 'FETCH_FIREBASE_DATA_SUCCESS';
export const FETCH_FIREBASE_DATA_FAILURE = 'FETCH_FIREBASE_DATA_FAILURE';